//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_PET,
  TITLE_COLOR_PET,
  ICON_COLOR_PET,
  FADE_BG_PET,
  LIGHT_BG_PET,
  FOOTER_BG_PET,
} from "../../utils/colors";

//IMPORTING FONTS
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import BannerAbout from "../../components/BannerAbout";
import LogoPet from "../../assets/logo/logo-mais-que-pet.png";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import ServicesCards from "../../components/ServicesCards";
import Pet1 from "../../assets/images/pet1.webp";
import Pet2 from "../../assets/images/pet2.webp";
import Pet3 from "../../assets/images/pet3.webp";
import { LuCircleCheckBig } from "react-icons/lu";
import { RiHeart2Line } from "react-icons/ri";
import StarsCall from "../../components/StarsCall";
import RecentPosts from "../../components/RecentPostsCall";
import bgPet from "../../assets/images/wallpaper-pet.webp";
import bgPetMobile from "../../assets/images/wallpaper-pet-mob.webp";
import "./MaisQuePet.css";

export default function MaisQuePet() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const petCards = [
    {
      id: 1,
      title: (
        <h3
          style={{
            color: ICON_COLOR_PET,
            fontSize: TITLE_SIZE,
            fontFamily: "Damion-Regular",
          }}
        >
          Amor Partilhado
        </h3>
      ),
      subTitle: (
        <h4 style={{ color: TITLE_COLOR_PET, fontSize: TEXT_SIZE }}>
          Serviço de Cremação <br />
          Coletiva
        </h4>
      ),
      image: Pet1,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Remoção até 100 km
          <br /> horário comercial 8h às 18h
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cremação coletiva
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Sem retorno de cinzas
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Certificado de cremação
        </p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item5: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Pet até 60 kg
        </p>
      ),
    },
    {
      id: 2,
      title: (
        <h3
          style={{
            color: ICON_COLOR_PET,
            fontSize: TITLE_SIZE,
            fontFamily: "Damion-Regular",
          }}
        >
          Amor Único
        </h3>
      ),
      subTitle: (
        <h4 style={{ color: TITLE_COLOR_PET, fontSize: TEXT_SIZE }}>
          Serviço de Cremação Individual
        </h4>
      ),
      image: Pet2,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Remoção até 100 km
          <br /> horário comercial 8h às 18h
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cremação individual
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Urna de cinzas padrão
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Certificado de cremação
        </p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item5: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Pet até 60 kg
        </p>
      ),
    },
    {
      id: 3,
      title: (
        <h3
          style={{
            color: ICON_COLOR_PET,
            fontSize: TITLE_SIZE,
            fontFamily: "Damion-Regular",
          }}
        >
          Amor Infinito
        </h3>
      ),
      subTitle: (
        <h4 style={{ color: TITLE_COLOR_PET, fontSize: TEXT_SIZE }}>
          Serviço de Cremação Individual
          <br />
          com Sala de Despedida
        </h4>
      ),
      image: Pet3,
      icon1: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item1: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Remoção até 100 km
          <br />
          disponível 24h
        </p>
      ),
      icon2: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item2: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Preparação do Pet
        </p>
      ),
      icon3: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item3: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cerimonial Pet
        </p>
      ),
      icon4: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item4: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Cremação individual
        </p>
      ),
      icon5: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item5: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Urna de cinzas padrão
        </p>
      ),
      icon6: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item6: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Certificado de cremação
        </p>
      ),
      icon7: (
        <LuCircleCheckBig
          style={{ color: ICON_COLOR_PET }}
          className="services-icon-card"
        />
      ),
      item7: (
        <p style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
          Pet até 60 kg
        </p>
      ),
    },
  ];

  return (
    <div className="MaisQuePet">
      <DynamicTitle
        pageTitle="Grupo Krause - Mais Que Pet"
        pageMeta="Mais Que Pet"
        pageContent="Com o Mais Que Pet você garante uma despedida digna e emocionante ao seu pet, que fez e sempre fará parte da sua história."
      />
      <BannerSection
        white={WHITE}
        //fadeBG={FADE_BG_PET}
        // iconTitle={
        //   <LuPawPrint
        //     style={{ color: WHITE }}
        //     className="banner-section-icon"
        //   />
        // }
        //bannerTitle={"DESPEDIDAS PARA PETS"}
        bannerTitleSize={TITLE_SIZE}
        //bannerSubTitle={"Homenagem ao amor incondicional do seu pet."}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={bgPet}
        bannerBGmobile={bgPetMobile}
      />
      <BannerAbout
        companyBrand={LogoPet}
        firstText={` Com ele, você garante uma despedida digna e emocionante ao amigo que
            fez e sempre fará parte da sua história, lembrando dele como
            realmente era: um membro da família.
`}
        secondText={` O Grupo Krause é uma das marcas mais tradicionais e reconhecidas de
            Novo Hamburgo e região. São milhares de famílias atendidas pelas
            quatro marcas do Grupo - Funerária Krause, Krause Assistencial,
            Memorial Krause e Mais Que Pet - que compõem o pacote de serviços
            funerários mais completo da região do Vale dos Sinos.
`}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <ServicesCards
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        titleSize={TITLE_SIZE}
        textSize={SUB_TEXT_SIZE}
        cards={petCards}
        cardSize={580}
        textTop={184}
      />
      <Container>
        <Row>
          <Col className="request-first-col">
            <h2 style={{ color: TITLE_COLOR_PET, fontSize: TITLE_SIZE }}>
              <RiHeart2Line
                style={{ color: ICON_COLOR_PET }}
                className="request-icon"
              />
              O QUE FAZER QUANDO CHEGA A HORA DA DESPEDIDA
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="request-col">
            <div className="request-card">
              <div
                style={{ backgroundColor: LIGHT_BG_PET }}
                className="request-circle"
              >
                <div className="request-icon-phone" />
                <h3 style={{ color: ICON_COLOR_PET, fontSize: SUB_TITLE_SIZE }}>
                  PASSO 1
                </h3>
              </div>
              <div
                style={{ backgroundColor: WHITE }}
                className="request-card-text"
              >
                <h4
                  style={{ color: TITLE_COLOR_PET, fontSize: SUB_TITLE_SIZE }}
                >
                  Contato com nossa equipe
                </h4>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Ligue para{" "}
                  <a
                    href="tel:05130369660"
                    style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}
                    className="request-link"
                  >
                    (51) 3036 9660 - Opção 4 <br />
                  </a>{" "}
                  ou chame pelo{" "}
                  <a
                    href="https://wa.me/555194141188"
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}
                    className="request-link"
                  >
                    WhatsApp 51 99414 1188
                  </a>
                  <br />
                  Nossa equipe irá orientar sobre todos os detalhes do serviço
                  já contratado ou apresentar as opções de despedidas
                  disponíveis para uso imediato.
                </p>
              </div>
            </div>
            <div className="request-box-dots">
              <div className="request-dots-one" />
              <div className="request-dots-two" />
              <div className="request-dots-three" />
            </div>
            <div className="request-card">
              <div
                style={{ backgroundColor: LIGHT_BG_PET }}
                className="request-circle"
              >
                <div className="request-icon-car" />
                <h3 style={{ color: ICON_COLOR_PET, fontSize: SUB_TITLE_SIZE }}>
                  PASSO 2
                </h3>
              </div>
              <div
                style={{ backgroundColor: WHITE }}
                className="request-card-text"
              >
                <h4
                  style={{ color: TITLE_COLOR_PET, fontSize: SUB_TITLE_SIZE }}
                >
                  Buscamos seu pet
                </h4>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Após a solicitação, iremos até o local indicado para realizar
                  a busca do seu animalzinho com todo cuidado e respeito.
                </p>
                <ul>
                  <li style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                    Serviço de Cremação Individual com Sala de Despedida:
                    remoção 24h, sem custo adicional, já inclusa no serviço.
                  </li>
                  <li style={{ color: TEXT_COLOR, fontSize: SUB_TEXT_SIZE }}>
                    Demais contratos: atendimento das 8h às 18h. Para finais de
                    semana e feriados, há taxa adicional de R$150,00.
                  </li>
                </ul>
              </div>
            </div>
            <div className="request-box-dots">
              <div className="request-dots-one" />
              <div className="request-dots-two" />
              <div className="request-dots-three" />
            </div>
            <div className="request-card">
              <div
                style={{ backgroundColor: LIGHT_BG_PET }}
                className="request-circle"
              >
                <div className="request-icon-heart" />
                <h3 style={{ color: ICON_COLOR_PET, fontSize: SUB_TITLE_SIZE }}>
                  PASSO 3
                </h3>
              </div>
              <div
                style={{ backgroundColor: WHITE }}
                className="request-card-text"
              >
                <h4
                  style={{ color: TITLE_COLOR_PET, fontSize: SUB_TITLE_SIZE }}
                >
                  Cremação
                </h4>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Encaminharemos seu pet para a cremação individual ou coletiva,
                  de acordo com a despedida contratada previamente ou de forma
                  imediata no momento do atendimento.
                </p>
              </div>
            </div>
            <div className="request-box-dots">
              <div className="request-dots-one" />
              <div className="request-dots-two" />
              <div className="request-dots-three" />
            </div>
            <div className="request-card">
              <div
                style={{ backgroundColor: LIGHT_BG_PET }}
                className="request-circle"
              >
                <div className="request-icon-box" />
                <h3 style={{ color: ICON_COLOR_PET, fontSize: SUB_TITLE_SIZE }}>
                  PASSO 4
                </h3>
              </div>
              <div
                style={{ backgroundColor: WHITE }}
                className="request-card-text"
              >
                <h4
                  style={{ color: TITLE_COLOR_PET, fontSize: SUB_TITLE_SIZE }}
                >
                  Momento especial de entrega
                </h4>
                <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
                  Nos casos de cremação individual, nossa equipe entrará em
                  contato para agendar o momento especial de entrega da urna com
                  as cinzas, garantindo acolhimento e respeito nessa etapa tão
                  significativa.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <StarsCall
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        primaryBtnColor={PRIMARY_BTN_PET}
      />
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        textColor={TEXT_COLOR}
        btnColor={ICON_COLOR_PET}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_PET}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_PET}
        titleColor={TITLE_COLOR_PET}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_PET}
        circleBG={LIGHT_BG_PET}
        btnColor={PRIMARY_BTN_PET}
      />
      <FooterBar titleColor={TITLE_COLOR_PET} footerBarBG={FOOTER_BG_PET} />
    </div>
  );
}
